export default __webpack_public_path__ + "1c8a811f78c9d0573f18e80d1b4283a8.pdf";